export * from './listaPaginada';
export * from './OSDetalhada';
